import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IWorkflowSave } from "@/interfaces/workflow.interface";
import workflowService from "@/services/workflow.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateWorkflowProps = {
  formData: IWorkflowSave;
} & RequestsProps;

export type UseCreateWorkflowReturn = {
  save: (props: CreateWorkflowProps) => Promise<void>;
} & UseLoadingReturn;

const useSaveWorkflow = (): UseCreateWorkflowReturn => {
  const {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create: save,
  } = useCreate<IWorkflowSave>({
    operation: (formData) => workflowService.save(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    save,
  };
};

export default useSaveWorkflow;
